import { useEffect, useState } from 'react';
import Select from './../../components/SelectInput';
import { getGlobalOptions } from '../../services/auth/selfSignUp';
import { enumGlobalOptionData } from '../../utils/enumGlobalOptionData';
import { convertForSelect } from '../../utils/convertApiData';
import { toast } from '../../components/AppToast';
import { useSelector } from 'react-redux';
import Input from "../../components/InputBox";

const WelcomePage = ({ formData, setFormData, dataFor }) => {
    const [organizationtypeOptions, setOrganizationtypeOptions] = useState([]);
    const { isLogin } = useSelector((state) => state?.login)

    const getOrgType = async () => {
        try {
            const getOption = await getGlobalOptions(dataFor === "partner" ? enumGlobalOptionData["PRT_TYPE"] : enumGlobalOptionData["ORG_TYPE"]);
            setOrganizationtypeOptions(convertForSelect(getOption));
        } catch (err) {
            toast.error(err);
        }
    }
    useEffect(() => {
        getOrgType()
        // eslint-disable-next-line
    }, []);


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const brandLogoSrc = `${process.env.PUBLIC_URL || ""}/logoNew.svg`;

    return (
        <div className='card_content'>
            {dataFor === "tenant" && !isLogin && (
                <div className="onboarding-welcome-hero">
                    <div className="onboarding-welcome-brand">
                        <img src={brandLogoSrc} alt="Trangile" width={280} height={80} decoding="async" />
                    </div>
                    <h4 className="onboarding-page-title">Welcome to Trangile Partner Portal !</h4>
                    <p className="onboarding-page-subtitle">We are excited to have you here. Please follow the steps to complete your registration.</p>
                </div>
            )}
            {dataFor === "tenant" && <Select isRequired options={organizationtypeOptions} className="select-input" label={"Organization Type"} name={`${dataFor}_type`} value={formData?.[`${dataFor}_type`]} onChange={handleChange} />}
            {dataFor === "partner" && (
                <>
                    <h4>Create Partner </h4>
                    {/* <p>We are excited to have you here. Please follow the steps to complete your registration.</p> */}
                    <div className="card_container">
                        <Input
                            isRequired
                            className={"input"}
                            label="Partner Name"
                            name="partner_name"
                            value={formData?.partner_name}
                            onChange={handleChange}
                        />
                        <Input
                            isRequired
                            className={"input"}
                            label="Contact Number"
                            name="partner_mobile"
                            value={formData?.partner_mobile}
                            onChange={handleChange}
                        />
                        <Input
                            isRequired
                            className={"input"}
                            label="Email Address"
                            name="partner_email"
                            value={formData?.partner_email}
                            onChange={handleChange}
                        />
                        <Select
                            isRequired
                            options={organizationtypeOptions}
                            className="select-input"
                            label="Partner Type"
                            name={`${dataFor}_type`}
                            value={formData?.[`${dataFor}_type`]}
                            onChange={handleChange}
                        />
                    </div>
                </>
            )}


        </div>
    )
}

export default WelcomePage;